import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserNavigationService } from 'src/app/services/user-navigation.service';
import { LoggingMessageService } from 'src/app/services/logging-message.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { PendoService } from 'src/app/services/pendo.service';
import { IframeService } from 'src/app/services/iframe.service';
import { SubscriptionChangeService } from 'src/app/services/subscription-change.service';

@Component({
  standalone: true,
  selector: 'app-blank-page',
  templateUrl: './blank-page.component.html'
})

export class BlankPageComponent implements OnInit, OnDestroy {
  private $subscriptions: Subscription = new Subscription();
  private linkid: string;
  selectedSubscriptionID: number;
  availableSubscriptions: string;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private logger: LoggingMessageService,
    private navigationService: UserNavigationService,
    private pendoService: PendoService,
    public iframeService: IframeService,
    private authService: AuthService,
    private sessionService: SessionStorageService,
    private subscriptionService: SubscriptionChangeService) {


    const navigationSubscription = this.router.events
      .subscribe((e: any) => {
        if (e instanceof NavigationEnd) {
          this.handleBlankPageNavigationEvent(e);
        }
      });
    this.$subscriptions.add(navigationSubscription);
  }

  ngOnInit() {
    this.selectedSubscriptionID = this.subscriptionService.SelectedSubscription;
    this.availableSubscriptions =  this.subscriptionService.AvailableSubscriptionsString;
  }

  private updateLinkId() {
    const linkId = this.route.snapshot.queryParams.linkid;
    if (linkId) {
      this.linkid = linkId;
    }
  }

  updatePendo() {
    const w: any = window;
    this.pendoService.updatePendo(w);
  }

  private handleBlankPageNavigationEvent(e: NavigationEnd) {
    this.updateLinkId();
    this.updatePendo();

    const user = this.authService.getUser();
    this.logger.debug('blank-page', 'handleBlankPageNavigationEvent',  this.selectedSubscriptionID, this.availableSubscriptions , `Changing NavLink id: ${this.linkid}`, '');

    this.iframeService.setSubDomainsToBlank();

    this.navigationService.emitNavigationComplete(this.linkid);
  }

  private Unsubscribe() {
    if (this.$subscriptions) {
      this.$subscriptions.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.Unsubscribe();
  }

}
